import { render, staticRenderFns } from "./ModalTeacherSkillInfo.vue?vue&type=template&id=1f8e3d88&scoped=true&"
import script from "./ModalTeacherSkillInfo.vue?vue&type=script&lang=js&"
export * from "./ModalTeacherSkillInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalTeacherSkillInfo.vue?vue&type=style&index=0&id=1f8e3d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8e3d88",
  null
  
)

export default component.exports